import React, { useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import playerImg from '@assets/images/placeholder/Placeholder_Player.svg'
// import CustomLink from '@shared/components/customLink'
import teamPlaceholder from 'assets/images/placeholder/team-placeholder.svg'
import { BLUR_DATA_URL_BASE64, S3_PREFIX } from '@shared-submodule/sm-constants'
import { calculateAge, getPlayerRole } from '@shared-submodule/utils'
import comparePlayer from '@assets/images/comparePlayer.svg'
import ComparePlayerPopup from '@shared/components/comparePlayer/comparePlayerPopup'

const MyImage = dynamic(() => import('@shared/components/myImage'))
const BreadcrumbNav = dynamic(() => import('@shared/components/breadcrumbNav'))
const PlayerHeader = ({ data }) => {
  const [isSearch, setIsSearch] = useState(false)
  function generateBettingStyle() {
    switch (data?.sPlayingRole) {
      case 'bat':
        return 'Batsman'
      case 'bowl':
        return 'Bowler'
      case 'all':
        return 'All Rounder'
      case 'wk':
        return 'Wicket Keeper'
      default:
        return ''
    }
  }

  return (
    <>
      <BreadcrumbNav dynamicName={data?.sFullName} />
      <section className={`${styles.playerHeader} d-flex align-items-start mt-3 mb-3 mb-md-4`}>
        <div className={`${styles.playerPic} overflow-hidden rounded-circle`}>
          <MyImage
            src={data?.oImg?.sUrl ? `${S3_PREFIX}${data?.oImg?.sUrl}` : playerImg}
            alt="user"
            blurDataURL={BLUR_DATA_URL_BASE64}
            placeholder="blur"
            layout="responsive"
            width="40"
            height="40"
            errorImage={playerImg}
          />
        </div>
        <div className={`${styles.content} flex-grow-1`}>
          <div className="d-flex gap-1 align-items-center">
            <div className={`${styles.playerName} mb-xl-0 m-0`}>{data?.sFullName || data?.sFirstName}</div>
            <div onClick={() => setIsSearch(true)} className={`${styles.compareBtn}`}>
              <MyImage src={comparePlayer} alt="Compare Player" /> Compare Player
            </div>
          </div>
          <div className={`${styles.info} d-flex justify-content-between flex-column flex-xl-row align-items-xl-baseline`}>
            <div className={`${styles.perInfo} d-flex align-items-center big-text flex-wrap mt-3 mb-1`}>
              <p className="mb-0 d-flex align-items-center">
                <div className={`${styles.teamImg} me-1 rounded-circle overflow-hidden flex-shrink-0`}>
                  <MyImage
                    src={data?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${data?.oTeam.oImg.sUrl}` : teamPlaceholder}
                    layout="responsive"
                    width="20"
                    height="20"
                    alt="team"
                    errorImage={teamPlaceholder}
                  />
                </div>
                {data?.sCountryFull}
              </p>
              {data?.dBirthDate && (
                <p className="mb-0 d-flex align-items-center">
                  {data?.dBirthDate ? `${calculateAge(data?.dBirthDate)} Years` || '-' : '-'}
                </p>
              )}
              {data?.sBattingStyle && <p className={`${styles.pType} mb-1 mb-sm-0 d-flex align-items-center`}>{generateBettingStyle()}</p>}
            </div>
          </div>
        </div>
      </section>
      <div className={'d-flex gap-2 justify-content-xl-start flex-wrap'}>
        {data?.aRanking?.map((rank, i) => (
          <div
            key={`#${rank.nRank}-${rank?.eRankType || getPlayerRole(data.sPlayingRole)}-in-${rank.eMatchType}-${i}`}
            className={`${styles.ranks} mt-xl-0`}>
            <div className={styles.btn}>
              {`# ${rank.nRank} ${rank?.eRankType || getPlayerRole(data.sPlayingRole)} in ${rank.eMatchType}`}
            </div>
          </div>
        ))}
      </div>

      {isSearch && <ComparePlayerPopup isSecond hide={() => setIsSearch(false)} playerId={data?._id} slug={data?.oSeo?.sSlug} />}
    </>
  )
}

PlayerHeader.propTypes = {
  data: PropTypes.object
}

export default PlayerHeader
